import { ChangeDetectorRef, Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { Location } from '@angular/common';
import { InstallationStaffPluginService } from './staff.service';
import { UntypedFormArray, UntypedFormBuilder, UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { ModalComponent } from '../../../modal/modal.component';
import { ConfirmComponent } from '../../../modal/confirm.component';
import { ActivatedRoute, Router } from '@angular/router';
import * as _ from 'lodash';
import { Subscription } from 'rxjs';
import { BaseInstallationEditPageComponent } from '../base-installation/edit-view.component';

@Component({
    selector: 'installation-staff-edit',
    templateUrl: './staff-edit.component.html',
    standalone: false
})
export class InstallationStaffEditPageComponent extends BaseInstallationEditPageComponent implements OnInit, OnDestroy {
  plugin: any;
  editForm: UntypedFormGroup;

  public staffTypes: any[];
  public staffToRemove: any;
  public currentItem: any;
  public provenanceItems = [
    {
      label: 'plugins.installationstaff.bobst-bsf',
      controlKey: 'bobstBSF'
    },
    {
      label: 'plugins.installationstaff.bobst-bcc',
      controlKey: 'bobstBCC'
    },
    {
      label: 'plugins.installationstaff.bobst-agent',
      controlKey: 'bobstAgent'
    },
    {
      label: 'plugins.installationstaff.customer',
      controlKey: 'customer'
    },
    {
      label: 'plugins.installationstaff.third-party',
      controlKey: 'thirdParty'
    },
    {
      label: 'plugins.installationstaff.non-applicable',
      controlKey: 'na'
    }
  ];

  private sub = new Subscription();

  @ViewChild('staffTypesModal', { static: true }) staffTypesModal: ModalComponent;
  @ViewChild('staffDeleteConfirm', { static: true }) staffDeleteConfirm: ConfirmComponent;

  constructor(
    protected activatedRoute: ActivatedRoute,
    protected router: Router,
    location: Location,
    protected cdRef: ChangeDetectorRef,
    protected pluginService: InstallationStaffPluginService,
    private fb: UntypedFormBuilder
  ) {
    super(location, pluginService, activatedRoute, router);
    this.staffTypes = pluginService.getStaffTypes();
  }

  get formData() {
    return <UntypedFormArray>this.editForm.controls['staff'];
  }

  ngOnInit(): void {
    this.sub.add(
      this.initRoute().subscribe(() => {
        this.initData();
      })
    );
  }

  public save(model: any) {
    this.processing = true;
    this.pluginService.updateStaff(this.inspectionId, this.pointId, this.pluginId, model).subscribe((el) => {
      this.processing = false;
      this.goToBack();
    });
  }

  public add() {
    const control = <UntypedFormArray>this.editForm.controls['staff'];
    control.push(this.initStaff());
  }

  public onClose(e: any) {
    this.editForm.controls['type'].markAsTouched();
    this.editForm.controls['provenance'].markAsTouched();
  }

  public selectStaffTypesMenu(item: any) {
    const selectedIndex = this.currentItem.controls['type'].value === item.selectedIndex ? '' : item.selectedIndex;
    this.currentItem.controls['type'].setValue(selectedIndex);
  }

  public openStaffTypesSelector(selectedIndex: number, i: number): void {
    this.openSelector(this.staffTypesModal, this.staffTypes, selectedIndex || selectedIndex === 0 ? selectedIndex : -1);
    const control = <UntypedFormArray>this.editForm.controls['staff'];
    this.currentItem = control.controls[i];
  }

  public checkIfPositive(event) {
    if (event.target.value < 0) event.target.value = 0;
  }

  public remove(e: any) {
    const control = <UntypedFormArray>this.editForm.controls['staff'];
    control.removeAt(this.staffToRemove);
  }

  public openStaffDeleteConfirm(i: number) {
    this.staffDeleteConfirm.open();
    this.staffToRemove = i;
  }

  public changeCheckboxValue(control) {
    control.setValue(!control.value);
  }

  ngOnDestroy(): void {
    this.sub.unsubscribe();
  }

  private initData() {
    this.staffTypes = this.pluginService.getStaffTypes();
    this.service.getPlugin(this.inspectionId, this.pluginId).subscribe((data) => {
      this.plugin = data;
      this.initForm();
      this.cdRef.detectChanges();
    });
  }

  private initForm() {
    this.editForm = this.fb.group({
      staff: this.fb.array([])
    });

    const control = <UntypedFormArray>this.editForm.controls['staff'];
    _.forEach(this.plugin.config.Staff, (el) => {
      control.push(this.initStaff(el));
    });
  }

  private initStaff(el?: any) {
    return this.fb.group({
      label: new UntypedFormControl(el && el.Label ? el.Label : ''),
      type: new UntypedFormControl(el && el.Type ? parseInt(el.Type) : ''),
      quantity: new UntypedFormControl(el && el.Quantity ? parseInt(el.Quantity) : ''),
      bobstBSF: new UntypedFormControl(el && el.BobstBSF != null ? el.BobstBSF : false),
      bobstBCC: new UntypedFormControl(el && el.BobstBCC != null ? el.BobstBCC : false),
      bobstAgent: new UntypedFormControl(el && el.BobstAgent != null ? el.BobstAgent : false),
      customer: new UntypedFormControl(el && el.Customer != null ? el.Customer : false),
      thirdParty: new UntypedFormControl(el && el.ThirdParty != null ? el.ThirdParty : false),
      na: new UntypedFormControl(el && el.NA != null ? el.NA : false),
      comment: new UntypedFormControl(el && el.Comment ? el.Comment : '')
    });
  }
}
